import { useState } from 'react';
import ExistingRulesGrid from './ExistingRulesGrid';
import { Grid, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { RulesType } from '../models/matcher.interface';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageTitle: {
      color: theme.palette.primary.dark,
      fontWeight: 'bold',
    },
    gridSpacer: {
      minHeight: '12px',
    },
  }),
);

export interface IExistingRules {
  rules: RulesType[]
  loadRules: () => void
}

const ExistingRules = ({ rules, loadRules }: IExistingRules) => {
  const classes = useStyles();
  const [error, setError] = useState<string>('');

  return (
    <>
      <Grid item xs={12}>
        <Grid container>
        </Grid>
        <Grid container className={classes.gridSpacer} />
        {error.length > 0 &&
          <Grid item xs={12}>
            <Alert severity="error" >
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
            <Grid container className={classes.gridSpacer} />
          </Grid>
        }
        <Grid item xs={12}>
          <ExistingRulesGrid
            setError={setError}
            rules={rules}
            loadRules={loadRules}
          />
        </Grid>
      </Grid>
    </>
  )
};

export default ExistingRules;
